module.exports = __webpack_public_path__ + "static/img/loading.aa129e8a.gif";